import RoofRange from "./RoofRange";
import Konva from "konva";
import { Global } from "../utilities/global";
import { SC_Input } from "../input/SC_Input";
import { Statics } from "../utilities/statics";
import { Point } from "../area/Point";
import { ScaleAdjustmentValue } from "../getScaleFactor";
import { Modul } from '../panel/Modul';
import { ModulProp } from '../panel/ModulProp';
import { Sol50 } from '../mountsys/Sol50';
import { DrawRoofForPanel } from '../panel/drawRoofForPanel';
import { Sol50Integrated } from '../mountsys/Sol50Integrated';
import DrawPanels from "../konva/drawPanels";

export class PartialHip {
	static nRoofHeight: number;
	static nRoofWidth: number;
	// Height of area H
	nHeightH: number;
	// Hip height
	static nHipHeight: number;
	// Hip Top Width
	static nHipTopWidth: number;
	// Hip Top Left
	static nHipTopLeft: number;
	// Hip Bottom Left
	static nHipBottomLeft: number;
	// Height of area H of the hip
	nHipHeightH: number;
	// Wing
	static nWing: number;
	// Wing of area H
	nWingH: number;
	// Top of area H
	nHTopY: number;
	// Hip Top Width of area H
	nTopWidthH: number;
	// Height of rectangular area H
	nRectHeightH: number;
	// Bottom Width
	nHBottomWidth: number;
	nE10Bottom: number;
	nE10Top: number;
	nE10Side: number;
	nE4Bottom: number;
	nE4Side: number;
	static rrFSideLeft: RoofRange;
	static rrFSideRight: RoofRange;
	static rrFBottomLeft: RoofRange;
	static rrFBottomRight: RoofRange;
	static rrFBottomLeftV: RoofRange;
	static rrFBottomRightV: RoofRange;
	static rrFTopLeftV: RoofRange;
	static rrFTopRightV: RoofRange;
	static rrGTop: RoofRange;
	static rrGBottom: RoofRange;
	static rrGLeft: RoofRange;
	static rrGRight: RoofRange;

	fitPartialHip(): void {
		var modulTmp: Modul;
		var i: number, j: number;
		var iRowTop: number, iBestRowTop: number;
		var iRowBottom: number, iNumRows: number;
		var nMaxW: number, nCurY: number, nDifLeft: number;
		var nCenterVal: number;
		var iMaxMod: number;
		var nModWidth: number, nModHeight: number;
		var iCols: number;
		if (SC_Input.iModAlignment == ModulProp.ORIENTATION_HORIZONTAL) {
			nModWidth = SC_Input.nModHeight / 10;
			nModHeight = SC_Input.nModWidth / 10;
		} else {
			nModWidth = SC_Input.nModWidth / 10;
			nModHeight = SC_Input.nModHeight / 10;
		}
		iNumRows = Math.floor(Sol50.getAvailHeight(PartialHip.nRoofHeight) / nModHeight);
		const allPanels = [];
		for (i = 1; i <= iNumRows; i++) {
			nCurY = PartialHip.nRoofHeight - (((nModHeight + Sol50.nVertikalAbstand) * i) + Sol50.nVertikalAbschluss);
			if (nCurY < PartialHip.nHipHeight) {
				nDifLeft = (PartialHip.nWing / PartialHip.nHipHeight) * nCurY;
				nMaxW = PartialHip.nHipTopWidth + (nDifLeft * 2);
			} else {
				nDifLeft = (PartialHip.nRoofWidth - PartialHip.nHipTopWidth) / 2;
				nMaxW = PartialHip.nRoofWidth;
			}
			iCols = Sol50.calcCols(nMaxW, nModWidth);
			nCenterVal = (nMaxW - (iCols * (nModWidth + Sol50.nHorizontalAbstand))) / 2;
			for (j = 0; j < iCols; j++) {
				var x = ((nModWidth + Sol50.nHorizontalAbstand) * j) + (PartialHip.nWing - nDifLeft) + nCenterVal;
				var y = nCurY;
				allPanels.push({x: ScaleAdjustmentValue.getScaleAdjust(x), y: ScaleAdjustmentValue.getScaleAdjust(y), w: nModWidth, h: nModHeight});
				// modulTmp = new Modul(ScaleAdjustmentValue.getScaleAdjust(x), ScaleAdjustmentValue.getScaleAdjust(y), nModWidth, nModHeight);
				// modulTmp.draw(DrawRoofForPanel.panelGroup);
				// modulTmp.draw();
				// Global.pageDesign.canMod.addChild(modulTmp);
			}
		}
		new DrawPanels().drawPanels(allPanels);
	}
	fitPartialHipIntegrated(): void {
		var modulTmp: Modul;
		var i: number, j: number;
		var nMaxW: number, nCurY: number, nDifLeft: number;
		var nCenterVal: number;
		var nModWidth: number, nModHeight: number;
		var iCols: number, iRows: number;
		var iTryStep: number;
		var nWingFactor: number;
		var iMaxMod: number;
		var iMaxCol: number = 0;
		var iMaxRow: number = 0;
		var iMaxStartY: number = 0;
		var nMaxGenWidth: number;
		var nCurX: number;

		if (SC_Input.iModAlignment == ModulProp.ORIENTATION_HORIZONTAL) {
			nModWidth = SC_Input.nModHeight / 10;
			nModHeight = SC_Input.nModWidth / 10;
		} else {
			nModWidth = SC_Input.nModWidth / 10;
			nModHeight = SC_Input.nModHeight / 10;
		}
		nWingFactor = ((PartialHip.nHipTopLeft - PartialHip.nHipBottomLeft) / PartialHip.nHipHeight);
		//Mit 50cm-Schritten probieren
		iTryStep = 50;
		iMaxMod = 0;
		i = PartialHip.nRoofHeight - (nModHeight + Sol50Integrated.nEindeckblechZusatz);
		while (i > iTryStep) {
			if (i < PartialHip.nHipHeight) {
				//i befindet sich in Walm-Bereich
				nDifLeft = nWingFactor * (PartialHip.nHipHeight - i);
				//available width
				nMaxW = PartialHip.nRoofWidth - (nDifLeft * 2);
			} else {
				nMaxW = PartialHip.nRoofWidth;
			}
			//generator width
			nMaxGenWidth = nMaxW - Sol50Integrated.nRandLeftRight;
			iCols = Sol50.calcCols(nMaxGenWidth, nModWidth);
			iRows = Sol50.calcRowsFromHeight(PartialHip.nRoofHeight - i, nModHeight);
			if (iMaxMod <= iCols * iRows) {
				iMaxMod = iCols * iRows;
				iMaxCol = iCols;
				iMaxRow = iRows;
				iMaxStartY = i;
			} else {
				break;
			}
			i -= nModHeight + Sol50.nVertikalAbstand;
		}
		if (iMaxMod == 0) {
			//Keine Module bebaubar
			return;
		}
		//nDifLeft einmalig berechnen, da x-Position immer gleich bleibt
		nCurY = iMaxStartY;
		if (nCurY < PartialHip.nHipHeight) {
			nDifLeft = nWingFactor * (PartialHip.nHipHeight - nCurY);
		} else {
			nDifLeft = 0;
		}
		nCenterVal = (PartialHip.nRoofWidth - (nDifLeft * 2)) - (iMaxCol * (nModWidth + Sol50.nHorizontalAbstand) - Sol50.nHorizontalAbstand);//((nMaxW - Sol50.nHorizontalAbstand) - (iMaxCol * (nModWidth + Sol50.nHorizontalAbstand))) / 2;
		nCenterVal = nCenterVal / 2;
		const allPanels: any = [];
		for (i = 0; i < iMaxRow; i++) {
			nCurY = iMaxStartY + (i * (nModHeight + Sol50.nVertikalAbstand));
			//				nDifLeft = nWingFactor * nCurY;
			for (j = 0; j < iMaxCol; j++) {
				// modulTmp = new Modul(nModWidth, nModHeight);
				var x = ((nModWidth + Sol50.nHorizontalAbstand) * j) + nDifLeft + nCenterVal;
				var y = nCurY;
				allPanels.push({x: ScaleAdjustmentValue.getScaleAdjust(x), y: ScaleAdjustmentValue.getScaleAdjust(y), w: nModWidth, h: nModHeight});
				// modulTmp = new Modul(ScaleAdjustmentValue.getScaleAdjust(x), ScaleAdjustmentValue.getScaleAdjust(y), nModWidth, nModHeight);
				// modulTmp.draw(DrawRoofForPanel.panelGroup);
			}
		}
		new DrawPanels().drawPanels(allPanels);
	}
	drawPartialHip(layer: Konva.Layer): void {
		var a: number, b: number, c: number, d: number;
		var iBuilding = SC_Input.iBuilding * 100;
		a = SC_Input.a;
		b = SC_Input.b;
		c = SC_Input.c;
		d = SC_Input.d;
		PartialHip.nRoofHeight = a + d;
		PartialHip.nRoofWidth = b;
		PartialHip.nWing = (b - c) / 2;
		PartialHip.nHipTopWidth = c;
		PartialHip.nHipTopLeft = PartialHip.nWing;
		PartialHip.nHipBottomLeft = 0;
		PartialHip.nHipHeight = d;
		this.nE10Bottom = Statics.getE10(b, iBuilding);
		this.nE4Bottom = Statics.getE4(b, iBuilding);
		this.nE10Top = Statics.getE10(c, iBuilding);
		this.nE10Side = Statics.getE10(PartialHip.nRoofHeight, iBuilding);
		this.nE4Side = Statics.getE4(a, iBuilding);

		var hipBg = new Konva.Line({
			points: [
				ScaleAdjustmentValue.getScaleAdjust(0), ScaleAdjustmentValue.getScaleAdjust(PartialHip.nRoofHeight),
				ScaleAdjustmentValue.getScaleAdjust(0), ScaleAdjustmentValue.getScaleAdjust(PartialHip.nHipHeight),
				ScaleAdjustmentValue.getScaleAdjust(PartialHip.nWing), ScaleAdjustmentValue.getScaleAdjust(0),
				ScaleAdjustmentValue.getScaleAdjust(b - PartialHip.nWing), ScaleAdjustmentValue.getScaleAdjust(0),
				ScaleAdjustmentValue.getScaleAdjust(b), ScaleAdjustmentValue.getScaleAdjust(PartialHip.nHipHeight),
				ScaleAdjustmentValue.getScaleAdjust(b), ScaleAdjustmentValue.getScaleAdjust(PartialHip.nRoofHeight)
			],
			fill: SC_Input.color,
			closed: true,
		});
		layer.add(hipBg);
		layer.draw();
		this.createStaticsAreas(layer);

	}
	createStaticsAreas(layer: Konva.Layer) {
		var nX: number, nY: number;
		var nHTopLeft: number;
		var nCurY = this.nE10Top;
		var nDifLeft = (PartialHip.nWing / PartialHip.nHipHeight) * nCurY;
		this.nHBottomWidth = SC_Input.b - (this.nE10Side * 2);
		var nMaxW = SC_Input.c + (nDifLeft * 2);
		var c = nMaxW - (this.nE10Side * 2);
		this.nWingH = (this.nHBottomWidth - c) / 2;

		nHTopLeft = this.nWingH + this.nE10Side;
		/* F */
		//FBottomLeft
		PartialHip.rrFBottomLeft = new RoofRange(Global.colDachF);
		nX = 0;
		nY = PartialHip.nRoofHeight;
		PartialHip.rrFBottomLeft.pBottomLeft = new Point(nX, nY);

		nX = this.nE4Bottom;
		nY = PartialHip.nRoofHeight;
		PartialHip.rrFBottomLeft.pBottomRight = new Point(nX, nY);

		nX = 0;
		nY = PartialHip.nRoofHeight - this.nE10Bottom;
		PartialHip.rrFBottomLeft.pTopLeft = new Point(nX, nY);

		nX = this.nE4Bottom;
		nY = PartialHip.nRoofHeight - this.nE10Bottom;
		PartialHip.rrFBottomLeft.pTopRight = new Point(nX, nY);
		PartialHip.rrFBottomLeft.draw(layer);
		PartialHip.rrFBottomLeft.setLabel("F");

		//FBottomLeftV
		PartialHip.rrFBottomLeftV = new RoofRange(Global.colDachF);
		nX = 0;
		nY = PartialHip.nRoofHeight;
		PartialHip.rrFBottomLeftV.pBottomLeft = new Point(nX, nY);

		nX = this.nE10Side;
		nY = PartialHip.nRoofHeight;
		PartialHip.rrFBottomLeftV.pBottomRight = new Point(nX, nY);

		nX = 0;
		nY = PartialHip.nRoofHeight - this.nE4Side;
		PartialHip.rrFBottomLeftV.pTopLeft = new Point(nX, nY);

		nX = this.nE10Side;
		nY = PartialHip.nRoofHeight - this.nE4Side;
		PartialHip.rrFBottomLeftV.pTopRight = new Point(nX, nY);
		PartialHip.rrFBottomLeftV.draw(layer);
		//FTopLeftV
		PartialHip.rrFTopLeftV = new RoofRange(Global.colDachF);
		nX = 0;
		nY = PartialHip.nHipHeight + this.nE4Side;
		PartialHip.rrFTopLeftV.pBottomLeft = new Point(nX, nY);

		nX = this.nE10Side;
		nY = nY;
		PartialHip.rrFTopLeftV.pBottomRight = new Point(nX, nY);

		nX = 0;
		nY = PartialHip.nHipHeight;
		PartialHip.rrFTopLeftV.pTopLeft = new Point(nX, nY);

		nX = this.nE10Side;
		nY = nY;
		PartialHip.rrFTopLeftV.pTopRight = new Point(nX, nY);
		PartialHip.rrFTopLeftV.draw(layer);
		PartialHip.rrFTopLeftV.setLabel("F");
		//FSideLeft
		PartialHip.rrFSideLeft = new RoofRange(Global.colDachF);
		nX = 0;
		nY = PartialHip.nHipHeight;
		PartialHip.rrFSideLeft.pBottomLeft = new Point(nX, nY);

		nX = this.nE10Side;
		nY = PartialHip.nHipHeight;
		PartialHip.rrFSideLeft.pBottomRight = new Point(nX, nY);

		nX = PartialHip.nWing;
		nY = 0;
		PartialHip.rrFSideLeft.pTopLeft = new Point(nX, nY);

		nX = PartialHip.nWing + this.nE10Side;
		nY = 0;
		PartialHip.rrFSideLeft.pTopRight = new Point(nX, nY);
		PartialHip.rrFSideLeft.draw(layer);

		//FBottomRight
		PartialHip.rrFBottomRight = new RoofRange(Global.colDachF);
		nX = PartialHip.nRoofWidth - this.nE4Bottom;
		nY = PartialHip.nRoofHeight;
		PartialHip.rrFBottomRight.pBottomLeft = new Point(nX, nY);

		nX = PartialHip.nRoofWidth;
		nY = PartialHip.nRoofHeight;
		PartialHip.rrFBottomRight.pBottomRight = new Point(nX, nY);

		nX = PartialHip.nRoofWidth - this.nE4Bottom;
		nY = PartialHip.nRoofHeight - this.nE10Bottom;
		PartialHip.rrFBottomRight.pTopLeft = new Point(nX, nY);

		nX = PartialHip.nRoofWidth;
		nY = PartialHip.nRoofHeight - this.nE10Bottom;
		PartialHip.rrFBottomRight.pTopRight = new Point(nX, nY);
		PartialHip.rrFBottomRight.draw(layer);
		PartialHip.rrFBottomRight.setLabel("F");
		//FBottomRightV
		PartialHip.rrFBottomRightV = new RoofRange(Global.colDachF);
		nX = PartialHip.nRoofWidth - this.nE10Side;
		nY = PartialHip.nRoofHeight;
		PartialHip.rrFBottomRightV.pBottomLeft = new Point(nX, nY);

		nX = PartialHip.nRoofWidth;
		nY = PartialHip.nRoofHeight;
		PartialHip.rrFBottomRightV.pBottomRight = new Point(nX, nY);

		nX = PartialHip.nRoofWidth - this.nE10Side;
		nY = PartialHip.nRoofHeight - this.nE4Side;
		PartialHip.rrFBottomRightV.pTopLeft = new Point(nX, nY);

		nX = PartialHip.nRoofWidth;
		nY = PartialHip.nRoofHeight - this.nE4Side;
		PartialHip.rrFBottomRightV.pTopRight = new Point(nX, nY);
		PartialHip.rrFBottomRightV.draw(layer);
		//FTopRightV
		PartialHip.rrFTopRightV = new RoofRange(Global.colDachF);
		nX = PartialHip.nRoofWidth - this.nE10Side;
		nY = PartialHip.nHipHeight + this.nE4Side;
		PartialHip.rrFTopRightV.pBottomLeft = new Point(nX, nY);

		nX = PartialHip.nRoofWidth;
		nY = nY;
		PartialHip.rrFTopRightV.pBottomRight = new Point(nX, nY);

		nX = PartialHip.nRoofWidth - this.nE10Side;
		nY = PartialHip.nHipHeight;
		PartialHip.rrFTopRightV.pTopLeft = new Point(nX, nY);

		nX = PartialHip.nRoofWidth;
		nY = nY;
		PartialHip.rrFTopRightV.pTopRight = new Point(nX, nY);
		PartialHip.rrFTopRightV.draw(layer);
		PartialHip.rrFTopRightV.setLabel("F");

		//FSideRight
		PartialHip.rrFSideRight = new RoofRange(Global.colDachF);
		nX = PartialHip.nRoofWidth - this.nE10Side;
		nY = PartialHip.nHipHeight;
		PartialHip.rrFSideRight.pBottomLeft = new Point(nX, nY);

		nX = PartialHip.nRoofWidth;
		nY = PartialHip.nHipHeight;
		PartialHip.rrFSideRight.pBottomRight = new Point(nX, nY);

		nX = PartialHip.nRoofWidth - (PartialHip.nWing + this.nE10Side);
		nY = 0;
		PartialHip.rrFSideRight.pTopLeft = new Point(nX, nY);

		nX = PartialHip.nRoofWidth - PartialHip.nWing;
		nY = 0;
		PartialHip.rrFSideRight.pTopRight = new Point(nX, nY);
		PartialHip.rrFSideRight.draw(layer);


		/* G */
		//GBottom
		PartialHip.rrGBottom = new RoofRange(Global.colDachG);
		nX = this.nE4Bottom > this.nE10Side ? this.nE4Bottom : this.nE10Side;
		nY = PartialHip.nRoofHeight;
		PartialHip.rrGBottom.pBottomLeft = new Point(nX, nY);

		nX = this.nE4Bottom > this.nE10Side ? PartialHip.nRoofWidth - this.nE4Bottom : PartialHip.nRoofWidth - this.nE10Side;
		nY = PartialHip.nRoofHeight;
		PartialHip.rrGBottom.pBottomRight = new Point(nX, nY);

		nX = this.nE4Bottom > this.nE10Side ? this.nE4Bottom : this.nE10Side;
		nY = PartialHip.nRoofHeight - this.nE10Bottom;
		PartialHip.rrGBottom.pTopLeft = new Point(nX, nY);

		nX = this.nE4Bottom > this.nE10Side ? PartialHip.nRoofWidth - this.nE4Bottom : PartialHip.nRoofWidth - this.nE10Side;
		nY = PartialHip.nRoofHeight - this.nE10Bottom;
		PartialHip.rrGBottom.pTopRight = new Point(nX, nY);
		PartialHip.rrGBottom.draw(layer);
		PartialHip.rrGBottom.setLabel("G");
		//GTop
		PartialHip.rrGTop = new RoofRange(Global.colDachG);
		nX = nHTopLeft;
		nY = this.nE10Top;
		PartialHip.rrGTop.pBottomLeft = new Point(nX, nY);

		nX = PartialHip.nRoofWidth - nX;
		nY = this.nE10Top;
		PartialHip.rrGTop.pBottomRight = new Point(nX, nY);

		nX = PartialHip.nWing + this.nE10Side;
		nY = 0;
		PartialHip.rrGTop.pTopLeft = new Point(nX, nY);

		nX = PartialHip.nRoofWidth - nX;
		nY = 0;
		PartialHip.rrGTop.pTopRight = new Point(nX, nY);
		PartialHip.rrGTop.draw(layer);
		PartialHip.rrGTop.setLabel("G");

		//GLeft
		PartialHip.rrGLeft = new RoofRange(Global.colDachG);
		nX = PartialHip.rrFBottomLeftV.pTopLeft.x;
		nY = PartialHip.rrFBottomLeftV.pTopLeft.y < PartialHip.rrFBottomLeft.pTopLeft.y ? PartialHip.rrFBottomLeftV.pTopLeft.y : PartialHip.rrFBottomLeft.pTopLeft.y;
		PartialHip.rrGLeft.pBottomLeft = new Point(nX, nY);

		nX = PartialHip.rrFBottomLeftV.pTopRight.x;
		nY = nY;
		PartialHip.rrGLeft.pBottomRight = new Point(nX, nY);

		nX = PartialHip.rrFTopLeftV.pBottomLeft.x;
		nY = PartialHip.rrFTopLeftV.pBottomLeft.y;
		PartialHip.rrGLeft.pTopLeft = new Point(nX, nY);

		nX = PartialHip.rrFTopLeftV.pBottomRight.x;
		nY = nY;
		PartialHip.rrGLeft.pTopRight = new Point(nX, nY);
		PartialHip.rrGLeft.draw(layer);
		PartialHip.rrGLeft.setLabel("G");
		//GRight
		PartialHip.rrGRight = new RoofRange(Global.colDachG);
		nX = PartialHip.rrFBottomRightV.pTopLeft.x;
		nY = PartialHip.rrFBottomRightV.pTopLeft.y < PartialHip.rrFBottomRight.pTopLeft.y ? PartialHip.rrFBottomRightV.pTopLeft.y : PartialHip.rrFBottomRight.pTopLeft.y;
		PartialHip.rrGRight.pBottomLeft = new Point(nX, nY);

		nX = PartialHip.rrFBottomRightV.pTopRight.x;
		nY = nY;
		PartialHip.rrGRight.pBottomRight = new Point(nX, nY);

		nX = PartialHip.rrFTopRightV.pBottomLeft.x;
		nY = PartialHip.rrFTopRightV.pBottomLeft.y;
		PartialHip.rrGRight.pTopLeft = new Point(nX, nY);

		nX = PartialHip.rrFTopRightV.pBottomRight.x;
		nY = nY;
		PartialHip.rrGRight.pTopRight = new Point(nX, nY);
		PartialHip.rrGRight.draw(layer);
		PartialHip.rrGRight.setLabel("G");


	}
	public static getRangeByModule(oMod: Modul): string {
		if (PartialHip.rrFBottomLeft.isModuleInRange(oMod, PartialHip.rrFBottomLeft)) {
			return "f";
		}
		if (PartialHip.rrFBottomLeftV.isModuleInRange(oMod, PartialHip.rrFBottomLeft)) {
			return "f";
		}
		if (PartialHip.rrFBottomRight.isModuleInRange(oMod, PartialHip.rrFBottomLeft)) {
			return "f";
		}
		if (PartialHip.rrFBottomRightV.isModuleInRange(oMod, PartialHip.rrFBottomLeft)) {
			return "f";
		}
		if (PartialHip.rrFSideLeft.isModuleInRange(oMod, PartialHip.rrFBottomLeft)) {
			return "f";
		}
		if (PartialHip.rrFSideRight.isModuleInRange(oMod, PartialHip.rrFBottomLeft)) {
			return "f";
		}
		if (PartialHip.rrFTopLeftV.isModuleInRange(oMod, PartialHip.rrFBottomLeft)) {
			return "f";
		}
		if (PartialHip.rrFTopRightV.isModuleInRange(oMod, PartialHip.rrFBottomLeft)) {
			return "f";
		}
		if (PartialHip.rrGBottom.isModuleInRange(oMod, PartialHip.rrFBottomLeft)) {
			return "g";
		}
		if (PartialHip.rrGLeft.isModuleInRange(oMod, PartialHip.rrFBottomLeft)) {
			return "g";
		}
		if (PartialHip.rrGRight.isModuleInRange(oMod, PartialHip.rrFBottomLeft)) {
			return "g";
		}
		if (PartialHip.rrGTop.isModuleInRange(oMod, PartialHip.rrFBottomLeft)) {
			return "g";
		}
		return "h";
	}
}